<template>
  <app-ag-grid
    title="Tickets"
    :columnDefs="columnDefs"
    :rowData="tickets"
    :loading="loading"
    :mobileCard="mobileCard"
    @refresh="fetchTickets"
    :newBtn="false"
    @row-dbl-click="
      (data) => $router.push({ path: `tickets/${data._id}/edit` })
    "
  />
</template>

<script>
import AppAgGrid from "@/components/common/ag-grid.vue";

export default {
  name: "TicketsPage",
  components: { AppAgGrid },

  data() {
    return {
      loading: false,

      columnDefs: [
        { headerName: "Name", field: "name" },
        { headerName: "Phone", field: "phone" },
        { headerName: "Issue", field: "issueType" },

        {
          headerName: "Message",
          field: "message",
        },

        {
          headerName: "Status",
          field: "status",
        },

        {
          headerName: "Created At",
          field: "createdAt",
          valueFormatter: (p) => {
            if (!p.value) return "-";
            const d = new Date(p.value);
            return `${d.getDate().toString().padStart(2, "0")}-${(
              d.getMonth() + 1
            )
              .toString()
              .padStart(2, "0")}-${d.getFullYear()}`;
          },
        },

        {
          headerName: "User",
          field: "userId.name",
        },
        {
          headerName: "Email",
          field: "userId.email",
          width: 300,
        },
      ],
    };
  },

  computed: {
    tickets() {
      return this.$store.state.ticket.tickets;
    },

    mobileCard() {
      const statusColors = {
        OPEN: { background: "#fff7e6", color: "#b8720a" },
        IN_PROGRESS: { background: "#e6f0fb", color: "#0a5a90" },
        RESOLVED: { background: "#e6f7ec", color: "#15803d" },
      };

      return {
        title: (row) => row.name || "-",
        subtitle: (row) => row.issueType || "-",
        badge: (row) => ({
          text: row.status || "-",
          style: statusColors[row.status] || { background: "#f1f5f9", color: "#475569" },
        }),
        fields: (row) => [
          { label: "Phone", value: row.phone || "-" },
        ],
        actions: (row) => [
          {
            label: "Edit",
            icon: "mdi-pencil-outline",
            color: "#475569",
            onClick: () => this.$router.push({ path: `tickets/${row._id}/edit` }),
          },
        ],
      };
    },
  },

  created() {
    this.fetchTickets();
  },

  methods: {
    async fetchTickets() {
      this.loading = true;
      try {
        await this.$store.dispatch("ticket/getTickets");
      } catch (e) {
        this.$toast.error("Failed to load tickets");
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
